"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _LoadingConstants = require("./LoadingConstants");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: ", ";\n\n  &:not(:empty) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  ", ";\n  margin: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['small'];
};

var SpinnerOuter = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerOuter",
  componentId: "lhi4tq-0"
})(_templateObject(), function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow && "width: 100%; height: 100%;";
}, function (props) {
  return !props.grow && '8px';
});

var SpinnerInner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerInner",
  componentId: "lhi4tq-1"
})(_templateObject2(), function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents.default.span.withConfig({
  displayName: "UILoadingSpinner__SpinnerLabel",
  componentId: "lhi4tq-2"
})(_templateObject3(), function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var getClassName = function getClassName(className, use, displayResult) {
  return (0, _classNames.default)('private-spinner', className, _LoadingConstants.USE_CLASSES[use], {
    'private-spinner--showing-result': displayResult
  });
};

var getIconSize = function getIconSize(longhandSize) {
  return _LoadingConstants.ICON_SIZE_MAP[longhandSize] || _LoadingConstants.ICON_SIZE_MAP['small'];
};

var getIconColor = function getIconColor(use) {
  return _LoadingConstants.ICON_COLOR_MAP[use];
};

var renderIcon = function renderIcon(failed, resultIcon, longhandSize, use) {
  if (failed || !resultIcon) {
    return null;
  }

  return _react.default.createElement("div", {
    className: "private-spinner__result"
  }, _react.default.createElement(_UIIconHolder.default, {
    innerStyles: {
      lineHeight: 'inherit',
      verticalAlign: 'middle'
    },
    name: resultIcon,
    color: getIconColor(use),
    size: getIconSize(longhandSize)
  }));
};

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = (0, _extends2.default)({}, style, {
      minHeight: minHeight
    });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }

  return style;
};

var UILoadingSpinner =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UILoadingSpinner, _Component);

  function UILoadingSpinner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILoadingSpinner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILoadingSpinner).call(this, props));
    _this.handleDisplayResultFinish = _this.handleDisplayResultFinish.bind((0, _assertThisInitialized2.default)(_this));
    _this.getComputedStyle = (0, _memoizeOne.default)(getComputedStyle);
    _this.state = {
      displayResult: props.showResult
    };
    return _this;
  }

  (0, _createClass2.default)(UILoadingSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var showResult = this.props.showResult;

      if (showResult) {
        this.setResultDisplayTimeout();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var showResult = nextProps.showResult;

      if (this.state.displayResult !== showResult) {
        this.setState({
          displayResult: showResult
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.displayResult && this.state.displayResult) {
        this.setResultDisplayTimeout();
      } else if (prevState.displayResult && !this.state.displayResult) {
        clearTimeout(this.resultDisplayTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.resultDisplayTimeout);
    }
  }, {
    key: "setResultDisplayTimeout",
    value: function setResultDisplayTimeout() {
      var resultAnimationDuration = this.props.resultAnimationDuration;
      clearTimeout(this.resultDisplayTimeout);
      this.resultDisplayTimeout = setTimeout(this.handleDisplayResultFinish, resultAnimationDuration);
    }
  }, {
    key: "handleDisplayResultFinish",
    value: function handleDisplayResultFinish() {
      var onResultDisplayFinish = this.props.onResultDisplayFinish;
      onResultDisplayFinish();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          failed = _this$props.failed,
          showResult = _this$props.showResult,
          __className = _this$props.className,
          dataLoading = _this$props['data-loading'],
          grow = _this$props.grow,
          label = _this$props.label,
          labelCompletedText = _this$props.labelCompletedText,
          layout = _this$props.layout,
          minHeight = _this$props.minHeight,
          __resultAnimationDuration = _this$props.resultAnimationDuration,
          resultIcon = _this$props.resultIcon,
          role = _this$props.role,
          use = _this$props.use,
          showLabel = _this$props.showLabel,
          size = _this$props.size,
          style = _this$props.style,
          __onResultDisplayFinish = _this$props.onResultDisplayFinish,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "failed", "showResult", "className", "data-loading", "grow", "label", "labelCompletedText", "layout", "minHeight", "resultAnimationDuration", "resultIcon", "role", "use", "showLabel", "size", "style", "onResultDisplayFinish"]);
      var displayResult = this.state.displayResult;
      var computedLayout = layout || (grow ? 'centered' : 'inline');
      var computedLabelText = displayResult && !failed ? (0, _lazyEval.default)(labelCompletedText) : (0, _lazyEval.default)(label);
      var RenderedLabel = showLabel ? SpinnerLabel : 'span';
      var renderedLabelProps = {
        children: computedLabelText
      };

      if (showLabel) {
        renderedLabelProps.layout = computedLayout;
      } else {
        renderedLabelProps.className = 'sr-only';
      }

      var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
      var spinnerSizePx = parseInt(getSpinnerSize(longhandSize), 10);
      return _react.default.createElement(SpinnerOuter, (0, _extends2.default)({}, rest, {
        className: getClassName(className, use, displayResult),
        style: this.getComputedStyle(style, grow, minHeight),
        "data-loading": dataLoading !== undefined ? dataLoading : !showResult,
        layout: computedLayout,
        grow: grow,
        role: role,
        use: use
      }), _react.default.createElement(SpinnerInner, {
        size: longhandSize
      }, _react.default.createElement("div", {
        className: "private-spinner-wrapper"
      }, _react.default.createElement("svg", {
        className: "private-spinner__ring",
        height: spinnerSizePx,
        viewBox: "0 0 50 50",
        width: spinnerSizePx
      }, _react.default.createElement("circle", {
        className: "private-spinner__ring-background",
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        strokeWidth: "5"
      }), _react.default.createElement("circle", {
        className: "private-spinner__ring-path",
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        strokeWidth: "5"
      }))), renderIcon(failed, resultIcon, longhandSize, use)), _react.default.createElement(RenderedLabel, renderedLabelProps));
    }
  }]);
  return UILoadingSpinner;
}(_react.Component);

UILoadingSpinner.displayName = 'UILoadingSpinner';
UILoadingSpinner.propTypes = {
  'data-loading': _react.PropTypes.bool,
  failed: _react.PropTypes.bool,
  showResult: _react.PropTypes.bool,
  label: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
  labelCompletedText: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
  layout: _react.PropTypes.oneOf(['inline', 'centered']),
  minHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  grow: _react.PropTypes.bool,
  resultAnimationDuration: _react.PropTypes.number.isRequired,
  resultIcon: _react.PropTypes.string,
  use: _react.PropTypes.oneOf(Object.keys(_LoadingConstants.USE_CLASSES)),
  showLabel: _react.PropTypes.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _react.PropTypes.func
};
UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction.default,
  showLabel: false,
  size: 'small',
  use: 'link'
};
var _default = UILoadingSpinner;
exports.default = _default;
module.exports = exports.default;